import React, { useContext, useEffect, useState } from "react";
import { Modal, Button, TextInput, Label } from "flowbite-react";
import { HiEye, HiTrash, HiArrowLeft, HiPlus, HiPencil } from "react-icons/hi";
import GlobalContext from "../connections/GlobalContext";
import Swal from "sweetalert2";
import axios from "axios";
import Button_submit from "../components/Button_submit";
import DataTable from "react-data-table-component";
import engineGif from "../image/engine.gif";
import Head_data from "../components/Head_data";

const BrandsModels = ({ theme }) => {
  const { globalValue } = useContext(GlobalContext);

  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [showModels, setShowModels] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [model_open, setModel_open] = useState(false);
  const [model_open1, setModel_open1] = useState(false);
  const [mode, setMode] = useState("");
  const [mode1, setMode1] = useState("");
  const [brand_name, setBrand_name] = useState();
  const [model_name, setModel_name] = useState();
  const [temp_b, setTemp_b] = useState("");
  const [temp_m, setTemp_m] = useState("");
  const [loading, setLoading] = useState(false);

  const data = brands.map((brand, index) => ({
    id: index + 1,
    brand: brand,
  }));

  const [searchTerm, setSearchTerm] = useState("");
  const [filtered, setFiltered] = useState(data);

  const [searchModelText, setSearchModelText] = useState("");

  useEffect(() => {
    const filteredData = data.filter((brand) =>
      brand.brand?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFiltered(filteredData);
  }, [searchTerm, brands]);

  useEffect(() => {
    fetchBrands();
    fetchModels();
  }, []);

  const fetchBrands = async () => {
    setLoading(true); // Start loading
    try {
      const response = await fetch(globalValue + "/v_brand", {
        method: "GET",
        headers: { "x-access-token": sessionStorage.getItem("token") },
      });

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();
      const uniqueBrands = [...new Set(data.map((item) => item[0]))].sort();
      setBrands(uniqueBrands);
    } catch (error) {
      console.error("Error fetching brands:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const fetchModels = async () => {
    setLoading(true); // Start loading
    try {
      const response = await fetch(globalValue + "/v_modal", {
        method: "GET",
        headers: { "x-access-token": sessionStorage.getItem("token") },
      });

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();
      setModels(data);
    } catch (error) {
      console.error("Error fetching models:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const handlebrand_add = async (brand) => {
    setLoading(true);

    try {
      const response = await axios.post(`${globalValue}/add_brand`, { brand });

      if (response.data === "success") {
        Swal.fire("Added!", "Brand added successfully!", "success");
        fetchBrands();
        fetchModels();
        setModel_open(false);
      } else {
        Swal.fire("Error", "Failed to add the brand.", "error");
      }
    } catch (error) {
      console.error("Error adding brand:", error);
      Swal.fire("Error", "Something went wrong while adding!", "error");
    } finally {
      setLoading(false);
    }
  };

  const handlebrand_edit = async (brand, temp_b) => {
    setLoading(true);

    try {
      const response = await axios.post(`${globalValue}/edit_brand`, {
        brand,
        temp_b,
      });

      if (response.data === "success") {
        Swal.fire("Edited!", "Brand edited successfully!", "success");
        fetchBrands();
        fetchModels();
        setModel_open(false);
      } else {
        Swal.fire("Error", "Failed to edit the brand.", "error");
      }
    } catch (error) {
      console.error("Error editing brand:", error);
      Swal.fire("Error", "Something went wrong!", "error");
    } finally {
      setLoading(false);
    }
  };

  const handlemodel_add = async (selectedBrand, model_name) => {
    setLoading(true);

    try {
      const response = await axios.post(`${globalValue}/add_model`, {
        selectedBrand,
        model_name,
      });

      if (response.data === "success") {
        Swal.fire("Added!", "Model added successfully!", "success");
        fetchBrands();
        fetchModels();
        setModel_open1(false);
        setShowModels(false);
      } else {
        Swal.fire("Error", "Failed to add the model.", "error");
      }
    } catch (error) {
      console.error("Error adding model:", error);
      Swal.fire("Error", "Something went wrong while adding!", "error");
    } finally {
      setLoading(false);
    }
  };
  const handlemodel_edit = async (selectedBrand, model_name, temp_m) => {
    setLoading(true);

    try {
      const response = await axios.post(`${globalValue}/edit_model`, {
        selectedBrand,
        model_name,
        temp_m,
      });

      if (response.data === "success") {
        Swal.fire("Edited!", "Model edited successfully!", "success");
        fetchBrands();
        fetchModels();
        setModel_open1(false);
        setShowModels(false);
      } else {
        Swal.fire("Error", "Failed to edit the model.", "error");
      }
    } catch (error) {
      console.error("Error editing model:", error);
      Swal.fire("Error", "Something went wrong!", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleViewModels = (brand) => {
    setSelectedBrand(brand);
    setShowModels(true);
    setFilteredModels(models.filter((model) => model[1] === brand));
  };

  const handle_brand_delete = async (name) => {
    const confirmDelete = await Swal.fire({
      title: "Delete Brand",
      text: "Are you sure you want to delete this brand?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmDelete.isConfirmed) {
      setLoading(true);

      try {
        const response = await axios.post(`${globalValue}/delete_brand`, {
          name,
        });

        if (response.data === "success") {
          Swal.fire("Deleted!", "Brand deleted successfully!", "success");
          fetchBrands();
          fetchModels();
        } else {
          Swal.fire("Error", "Failed to delete the brand.", "error");
        }
      } catch (error) {
        console.error("Error deleting brand:", error);
        Swal.fire("Error", "Something went wrong while deleting!", "error");
      } finally {
        setLoading(false);
      }
    }
  };
  const handle_model_delete = async (id) => {
    const confirmDelete = await Swal.fire({
      title: "Delete Model",
      text: "Are you sure you want to delete this model?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmDelete.isConfirmed) {
      setLoading(true);

      try {
        const response = await axios.post(`${globalValue}/delete_model`, {
          id,
        });

        if (response.data === "success") {
          Swal.fire("Deleted!", "Model deleted successfully!", "success");
          fetchModels();
          fetchBrands();
          setShowModels(false);
        } else {
          Swal.fire("Error", "Failed to delete the model.", "error");
        }
      } catch (error) {
        console.error("Error deleting model:", error);
        Swal.fire("Error", "Something went wrong while deleting!", "error");
      } finally {
        setLoading(false);
      }
    }
  };
  const columns = [
    {
      name: "S No.",
      selector: (row, index) => index + 1,
      width: "120px",
      center: true,
    },
    {
      name: "Brand Name",
      selector: (row) => row.brand,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex justify-center gap-2">
          <button
            className="p-2 bg-blue-500 text-white rounded-lg shadow-md hover:bg-blue-600 transition duration-200"
            onClick={() => handleViewModels(row.brand)}
          >
            <HiEye className="text-lg" />
          </button>
          <button
            className="p-2 bg-yellow-500 text-white rounded-lg shadow-md hover:bg-yellow-600 transition duration-200"
            onClick={() => {
              setModel_open(true);
              setMode("edit");
              setTemp_b(row.brand);
              setBrand_name(row.brand);
            }}
          >
            <HiPencil className="text-lg" />
          </button>
          <button
            className="p-2 bg-red-500 text-white rounded-lg shadow-md hover:bg-red-600 transition duration-200"
            onClick={() => handle_brand_delete(row.brand)}
          >
            <HiTrash className="text-lg" />
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      center: true,
    },
  ];

  const customStyles = {
    table: {
      style: {
        backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
        width: "100%",
        border:
          theme === "dark"
            ? "solid 1px rgb(63, 62, 62)"
            : "solid 1px rgb(226, 232, 240)",
      },
    },
    headCells: {
      style: {
        backgroundColor:
          theme === "dark" ? "rgb(55, 65, 81)" : "rgb(226, 232, 240)",
        color: theme === "dark" ? "white" : "black",
        fontWeight: "bold",
      },
    },
    cells: {
      style: {
        color: theme === "dark" ? "white" : "black",
        backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
        border:
          theme === "dark"
            ? "solid 1px rgb(63, 62, 62)"
            : "solid 1px rgb(255, 255, 255)",
      },
    },
    pagination: {
      style: {
        backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
        color: theme === "dark" ? "white" : "black",
        borderTop:
          theme === "dark" ? "solid 1px white" : "solid 1px rgb(226, 232, 240)",
      },
      pageButtonsStyle: {
        backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
        color: theme === "dark" ? "white" : "black",
        fill: theme === "dark" ? "white" : "black",
        "&:hover": {
          backgroundColor:
            theme === "dark" ? "rgb(55, 65, 81)" : "rgb(226, 232, 240)",
        },
      },
    },
  };

  return (
    <div
      className={`md:ml-[250px] w-full md:w-[calc(100%-250px)] mt-16 h-[92vh] flex justify-center items-center box-border ${
        theme === "dark"
          ? "bg-gray-900 text-white"
          : "bg-gray-100 text-gray-800"
      }`}
    >
      <div
        className={`w-[95%] md:w-[98%] h-[95%] px-4 py-2 rounded-xl shadow-xl overflow-auto ${
          theme === "dark"
            ? "bg-gray-800 text-gray-200"
            : "bg-white text-gray-800"
        }`}
      >
        {loading && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
            <img src={engineGif} alt="Loading..." className="w-24 h-24" />
          </div>
        )}
        {!showModels ? (
          <div className=" bg-white">
            {/* Header Section */}
            <div className="flex justify-between items-center mb-4">
              <Head_data data="Manage Brands and Models" font="" size="3xl" />{" "}
              <Button
                className="px-5 py-2 bg-blue-600 text-white font-medium rounded-lg shadow-md hover:bg-blue-700 transition duration-200"
                onClick={() => {
                  setModel_open(true);
                  setMode("add");
                  setBrand_name("");
                }}
              >
                Add
              </Button>
            </div>

            <input
              type="text"
              placeholder="Search by brand name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full md:w-1/3 px-4 py-2 my-2 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
            />

            <DataTable
              columns={columns}
              data={filtered}
              pagination
              striped
              responsive
              customStyles={customStyles}
            />
          </div>
        ) : (
          <div>
            <div className="flex justify-between items-center mb-4">
              <button
                className="px-4 py-2 text-white bg-gray-600 rounded hover:bg-blue-700 md:mt-2"
                onClick={() => setShowModels(false)}
              >
                <HiArrowLeft className="text-white text-lg" />
              </button>
              <h2 className="text-2xl font-bold flex">
                <p className="hidden md:block me-2">Models for </p>{" "}
                {selectedBrand}
              </h2>

              <button
                className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700 md:mt-2"
                onClick={() => {
                  setMode1("add");
                  setModel_open1(true);
                  setModel_name();
                }}
              >
                Add
              </button>
            </div>
            <input
              type="text"
              placeholder="Search by Model"
              value={searchModelText}
              onChange={(e) => setSearchModelText(e.target.value)}
              className="w-full md:w-96 px-4 my-2 py-2 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
            />
            <table className="w-full border-collapse border border-gray-300">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border text-left border-gray-100 px-4 py-2">
                    Model Name
                  </th>
                  <th className="border border-gray-100 px-4 py-2">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredModels.map((model, index) => {
                  if (
                    model[2]
                      ?.toLowerCase()
                      .includes(searchModelText.toLowerCase())
                  ) {
                    return (
                      <tr key={index} className="text-start">
                        <td className="border border-gray-100 px-4 py-2">
                          {model[2]}
                        </td>
                        <td className="border border-gray-100 px-4 py-2 flex justify-center gap-2">
                          <button
                            className="p-2 text-white bg-yellow-500 hover:bg-yellow-600 rounded-md shadow-md transition duration-200"
                            onClick={() => {
                              setMode1("edit");
                              setModel_open1(true);
                              setModel_name(model[2]);
                              setTemp_m(model[0]);
                            }}
                          >
                            <HiPencil className="text-white text-lg" />
                          </button>

                          <button
                            className="p-2 text-white bg-red-500 hover:bg-red-600 rounded-md shadow-md transition duration-200"
                            onClick={() => {
                              handle_model_delete(model[0]);
                            }}
                          >
                            <HiTrash className="text-white text-lg" />
                          </button>
                        </td>
                      </tr>
                    );
                  } else {
                    return null;
                  }
                })}
              </tbody>
            </table>
          </div>
        )}

        <Modal show={model_open} onClose={() => setModel_open(false)}>
          <Modal.Header className="flowbite-modal-h">
            {mode == "add" ? "Add Brand" : "Edit Brand"}
          </Modal.Header>
          <Modal.Body className="flowbite-modal-b">
            <div>
              <Label htmlFor="license">Brand</Label>
              <TextInput
                id="license"
                type="text"
                value={brand_name}
                onChange={(e) => {
                  setBrand_name(e.target.value);
                }}
                required
                color="white"
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="flowbite-modal-b">
            <Button_submit
              onClick={() => {
                mode === "add"
                  ? handlebrand_add(brand_name)
                  : handlebrand_edit(brand_name, temp_b);
              }}
              data={`${mode === "add" ? "Submit" : "Update"}`}
              type="submit"
              aditional="ms-auto"
            />
          </Modal.Footer>
        </Modal>

        <Modal show={model_open1} onClose={() => setModel_open1(false)}>
          <Modal.Header className="bg-white text-gray-900 border-b border-gray-200">
            {mode1 == "add" ? "Add Model" : "Edit Model"}
          </Modal.Header>
          <Modal.Body className="flowbite-modal-b">
            <div>
              <Label htmlFor="license">Model</Label>
              <TextInput
                id="license"
                type="text"
                value={model_name}
                onChange={(e) => {
                  setModel_name(e.target.value);
                }}
                required
                color="white"
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="flowbite-modal-b">
            <Button_submit
              onClick={() => {
                mode1 === "add"
                  ? handlemodel_add(selectedBrand, model_name)
                  : handlemodel_edit(selectedBrand, model_name, temp_m);
              }}
              data={`${mode1 === "add" ? "Submit" : "Update"}`}
              type="submit"
              aditional="ms-auto"
            />
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default BrandsModels;
